import { useTranslation } from "react-i18next";
import { useTheme } from "@repo/tokens";
import { Box, Icon, Modal } from "@repo/ui";
import subscriptionModalSvg from "../../../../assets/instructions/Subscription_Modal.svg";
import "./trialExpiredModal.css";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onGoToSubscriptions: () => void;
  /** Stack above host overlays (e.g. AINA / LiveKit) when portaled to `document.body`. */
  overlayZIndex?: number;
};

export function TrialExpiredModal({
  isOpen,
  onClose,
  onGoToSubscriptions,
  overlayZIndex = 2100,
}: Props) {
  const { t } = useTranslation("doubts");
  const { theme } = useTheme();

  const body = (
    <Box className="trial-expired-modal__shell">
      <Box className="trial-expired-modal__header">
        <button
          type="button"
          className="trial-expired-modal__close"
          onClick={onClose}
          aria-label={t("cancel")}
        >
          <Icon
            name="close"
            width={24}
            height={24}
            color={theme.colors.primary[30]}
          />
        </button>
      </Box>
      <Box className="trial-expired-modal__body">
        <img
          src={subscriptionModalSvg}
          alt=""
          className="trial-expired-modal__illustration"
          width={380}
          height={339}
          decoding="async"
        />
        <Box
          style={{
            paddingBlock: 0,
            paddingInline: "4rem",
          }}
        >
          <button
            type="button"
            className="trial-expired-modal__cta"
            onClick={onGoToSubscriptions}
          >
            {t("go_to_subscriptions")}
          </button>
        </Box>
      </Box>
    </Box>
  );

  return (
    <Modal
      isModalOpen={isOpen}
      onClose={onClose}
      showHeader={false}
      showFooter={false}
      // No semantic modal-size token exists for this subscription upsell sheet.
      width="min(28rem, 92vw)"
      height="auto"
      modalClassName="trial-expired-modal__card"
      bodyClassName="trial-expired-modal__body-wrap"
      body={body}
      alignItems="center"
      styles={{
        overlay: { zIndex: overlayZIndex },
        modal: {
          borderRadius: "var(--radii-2xl)",
          overflow: "hidden",
          boxShadow:
            "0 25px 50px -12px rgba(15, 23, 42, 0.18), 0 0 0 1px rgba(15, 23, 42, 0.06)",
        },
        body: {
          padding: 0,
          overflow: "visible",
        },
      }}
    />
  );
}
